module.exports = __webpack_public_path__ + "img/1-icono-nuevo-tramite-selected.01924f56.svg";